module.exports = __webpack_public_path__ + "static/compare-costs-e2e399565e79738295866570314c3417.png";